import { z } from 'zod';

// File categories for AI description generation
export const fileCategorySchema = z.enum([
  'document',
  'spreadsheet',
  'presentation',
  'image',
  'video',
  'audio',
  'archive',
  'other'
]);

export type FileCategory = z.infer<typeof fileCategorySchema>;

// Request schemas
export const generateDescriptionRequestSchema = z.object({
  fileId: z.string(),
  category: fileCategorySchema,
  existingDescription: z.string().optional(),
  locale: z.string().optional(), // Language code (e.g., 'es', 'en')
});

export type GenerateDescriptionRequest = z.infer<typeof generateDescriptionRequestSchema>;

// Response schemas
export const generateDescriptionResponseSchema = z.object({
  description: z.string(),
  tags: z.array(z.string()),
  confidence: z.number().min(0).max(1),
});

export type GenerateDescriptionResponse = z.infer<typeof generateDescriptionResponseSchema>;

// Error types for AI operations
export type AIErrorCode =
  | 'AI_NOT_CONFIGURED'
  | 'RATE_LIMITED'
  | 'AI_AUTH_ERROR'
  | 'AI_SERVICE_ERROR';

export interface AIErrorResponse {
  error: AIErrorCode;
  message: string;
}
